import React, { useEffect, useState } from 'react'
import NewScheduleInterview from '../interview/NewScheduleInterview'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import axios from 'axios'
import { TeamMemberInterviewAction } from "./../../../Redux/action/TeamMemberInterviewAction";
import Pagination from '../../Common/Pagination/Pagination';
import { FaCheck } from "react-icons/fa6";
import { MdOutlineCancel } from "react-icons/md";
import DeactivateModal from '../../Common/DeactivateMemberModal'
import { CandidateInterviewPlanned } from "./../../../Redux/action/CandidateInterviewPlanned";
import { JobsInterviewPlannedAcceptAction } from "./../../../Redux/action/JobsInterviewPlannedAcceptAction";
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, TextareaAutosize } from "@mui/material";
import { SpinLoader } from '../ImportCandidates';
import { ToastContainer, toast } from 'react-toastify';

const InterviewListTeamMember = ({ limit }) => {
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false);
    const [selectedCandidates, setSelectedCandidates] = useState([]);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [interviewId, setInterviewId] = useState("")
    const [selectedReason, setSelectedReason] = useState(""); // To store the selected reason
    const [otherReason, setOtherReason] = useState("");
    const [showOtherTextarea, setShowOtherTextarea] = useState(selectedReason === "other");
    const [componentKey, setComponentKey] = useState(0);

    const [pageNumber, setPageNumber] = useState(0);
    const totalPages = useSelector((state) => state.TeamMemberInterviewReducer.result.totalPages);
    const { userResult } = useSelector((state) => state.Auth);
    const VENDORID = userResult?.vendorid;
    const baseUrl = process.env.REACT_APP_API_PATH;
    const navigate = useNavigate()
    const arr = [1]
    const [canInfo, setCanInfo] = useState('');
    const [open, setOpen] = useState(false);
    const renderData = useSelector((state) => state?.TeamMemberInterviewReducer?.result.content);
    const handleSchedule = (e, item) => {
        e.stopPropagation()
        setCanInfo(item);
        setOpen(true)
    }

    const handlePageChange = (page) => {
        setPageNumber(page);
    };

    useEffect(() => {
        try {
            dispatch(TeamMemberInterviewAction(VENDORID, pageNumber));
        } catch (error) {
            console.log("Error at InterviewListTeamMember", error)
        }
    }, [pageNumber])

    const handleCheck = (e, id) => {
        e.stopPropagation()
        AcceptInterview(id)
    }

    const AcceptInterview = async (interviewId) => {
        const content = {
            isAcceptedByCandidate: "ACCEPTED",
            interviewId,
        };
        await dispatch(JobsInterviewPlannedAcceptAction(content)).then((res) => {
            // console.log("TTTTTTTTRRRRRr",res);
            if (res?.data) {
                console.log("rr", res?.data);
                setTimeout(() => {
                    dispatch(TeamMemberInterviewAction(VENDORID, pageNumber))
                }, 1000)
            }

        })
    };

    const openModal = (e, intId) => {
        e.stopPropagation()
        setIsModalOpen(true);
        setInterviewId(intId)
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const handleReasonChange = (event) => {
        const value = event.target.value;
        setSelectedReason(value);

        // If "other" is selected, show the textarea
        setShowOtherTextarea(value === "other");
    };

    const handleOtherReasonChange = (event) => {
        setOtherReason(event.target.value);
    };

    const handleSubmit = async (e) => {
        e.stopPropagation();
        if (!selectedReason) {
            return toast.error("Please Select at least one option")
        }
        if (selectedReason === 'other' && otherReason.trim() === "") {
            return toast.error("Please give reason in option fields")
        }
        setLoading(true);
        let timeout;
        try {
            const content = {
                isAcceptedByCandidate: "REJECTED",
                declineReasonCandidate: selectedReason !== 'other' ? selectedReason : otherReason,
                interviewId
            }
            const response = await axios.put(`${baseUrl}/ebench/interview/accept_or_reject_interview`, content, {
                headers: {
                    "Content-Type": "application/json",
                },
            })

            const data = await response.data;

            timeout = setTimeout(() => {
                dispatch(TeamMemberInterviewAction(VENDORID, pageNumber))
            }, 1200);
            setLoading(false)
            setSelectedReason("")
            setSelectedCandidates([])
            closeModal();
            setComponentKey((prevKey) => prevKey + 1);
            toast.error('Interview Rejected')
        } catch (error) {
            setLoading(false)
            console.error("Error occurred", error);
            toast.error(error?.response?.data?.status?.message);
        }
        return () => {
            clearTimeout(timeout)
        }
    }

    return (
        <>
            <ToastContainer />

            <div className="common_wrapper mt-4" >
                <div className="card-header  common_table_header">
                    Team Member Interviews
                </div>

                <div className="card-body">
                    <div className="table-responsive">
                        <table className="table-data" style={{ width: '100%', textAlign: 'center', fontSize: '14px' }}>
                            <thead>
                                <tr>
                                    <th className="fw_500" scope="col">Job ID</th>
                                    {/* <th className="fw_500" scope="col">Round ID</th> */}
                                    <th className="fw_500" scope="col">Candidate Name</th>
                                    <th className="fw_500" scope="col">Round</th>
                                    <th className="fw_500" scope="col">Designation</th>
                                    <th className="fw_500" scope="col">Date</th>
                                    <th className="fw_500" scope="col">Start Time</th>
                                    <th className="fw_500" scope="col">Duration</th>

                                    {!limit && <th className="fw_500" scope="col">Interview Type</th>}
                                    {/* {!limit && <th className="fw_500" scope="col">Job ID</th>} */}
                                    {/* {!limit && <th className="fw_500" scope="col">Candidate Status</th>}
                                {!limit && <th className="fw_500" scope="col">Interviewer Status</th>} */}
                                    {!limit && <th className="fw_500" scope="col">Hiring Status</th>}
                                    <th className="fw_500" scope="col">Action</th>

                                </tr>
                            </thead>
                            <tbody>
                                {renderData &&
                                    renderData.map((item, i) => {
                                        return (
                                            <>
                                                {arr.map((element) => (
                                                    <>
                                                        <tr key={i}>
                                                            <td style={{ cursor: "pointer" }}
                                                                onClick={(e) => {
                                                                    navigate(
                                                                        `/view_job/${item.jobId}`
                                                                    )
                                                                }
                                                                }>{item.jobUuid}</td>
                                                            <td>{item.candidateName}</td>
                                                            <td style={{ cursor: "pointer" }}
                                                                onClick={() =>
                                                                    navigate(`/interview_all_rounds/${item.uuid}`, {
                                                                        state: { myData: "team" }, // 👈 send state here
                                                                    })
                                                                }>{item.round}</td>
                                                            <td>{item.jobPosition}</td>
                                                            <td> {
                                                                item?.interviewDate.split(" ")[0].split("-")[2] + "-" +
                                                                item?.interviewDate.split(" ")[0].split("-")[1] + "-" +
                                                                item?.interviewDate.split(" ")[0].split("-")[0]
                                                                || "N/A"}</td>
                                                            <td>
                                                                {item.interviewStartTime}
                                                            </td>
                                                            <td>{item.duration}</td>
                                                            {!limit && <>
                                                                <td>{item.inteviewType}</td>

                                                                {/* <td>
                                                                <div className={`w-75 m-auto ${(item.isAcceptedByCandidate === 'PENDING' || item.isAcceptedByCandidate === 'REJECTED') ? 'red_status' : 'green_status'}`}>
                                                                    {item.isAcceptedByCandidate === 'PENDING' ? 'Pending' : item.isAcceptedByCandidate === 'ACCEPTED' ? 'Accepted' : 'Rejected'}
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className={`w-75 m-auto ${(item.isAcceptedByInterviewer === 'PENDING' || item.isAcceptedByInterviewer === 'REJECTED') ? 'red_status' : 'green_status'}`}>
                                                                    {item.isAcceptedByInterviewer === 'PENDING' ? 'Pending' : item.isAcceptedByInterviewer === 'ACCEPTED' ? 'Accepted' : 'Rejected'}
                                                                </div>
                                                            </td> */}
                                                                {/* <td>{item.jobUuid}</td> */}

                                                                <td>
                                                                    {/* SELECT, REJECT, ONHOLD, PENDING, NEXT_ROUND , ccanelled*/}
                                                                    <div style={{ width: '100%' }} className={`w-75 m-auto ${["ONHOLD", "PENDING"].includes(item.candidateInterviewStatus)
                                                                            ? "yellow_status"
                                                                            : ["CANCELLED", "REJECT"].includes(item.candidateInterviewStatus)
                                                                                ? "red_status"
                                                                                : ["SELECT", "NEXT_ROUND"].includes(item.candidateInterviewStatus)
                                                                                    ? "green_status"
                                                                                    : ""
                                                                        }`}
                                                                    >
                                                                        {
                                                                            item.candidateInterviewStatus === 'ONHOLD' ? 'On Hold' :
                                                                                item.candidateInterviewStatus === 'NEXT_ROUND' ? 'Next Round' :
                                                                                    item.candidateInterviewStatus === 'SELECT' ? 'Selected' :
                                                                                        item.candidateInterviewStatus === 'REJECT' ? 'Rejected' :
                                                                                            item.candidateInterviewStatus === 'PENDING' ? 'In Progress' : item.candidateInterviewStatus
                                                                        }
                                                                    </div>
                                                                </td>
                                                            </>}
                                                            {(item?.isAcceptedByCandidate == "PENDING") && (item?.interviewStatus == "SCHEDULED") ? (
                                                                <>
                                                                    <td>
                                                                        <FaCheck
                                                                            size={23}
                                                                            color="#286a94"
                                                                            className="me-3 pointer"
                                                                            onClick={(e) => handleCheck(e, item?.interviewId)}
                                                                        />
                                                                        <MdOutlineCancel size={23}
                                                                            color="red" className="pointer" onClick={(e) => openModal(e, item?.interviewId)}>
                                                                        </MdOutlineCancel>
                                                                    </td>
                                                                </>
                                                            ) : (
                                                                <td>
                                                                    {
                                                                        item?.isAcceptedByCandidate
                                                                    }
                                                                </td>
                                                            )}
                                                        </tr>
                                                    </>
                                                ))}
                                            </>

                                        );
                                    })}
                            </tbody>
                        </table>
                        {renderData?.length === 0 && (
                            <div className="text-center mt-5">
                                <h5>No Data Available</h5>
                            </div>
                        )}
                    </div>
                </div>
                <DeactivateModal isOpen={isModalOpen} onClose={closeModal} heading={'Reason for Rejection'} >
                    <FormControl>
                        <FormLabel id="demo-radio-buttons-group-label">Reasons</FormLabel>
                        <RadioGroup
                            aria-labelledby="demo-radio-buttons-group-label"
                            // defaultValue="female"
                            name="radio-buttons-group"
                            value={selectedReason}
                            onChange={handleReasonChange}
                        >
                            <FormControlLabel className='mb-2' value="I am not available" control={<Radio />} label="I am not available" />

                            <FormControlLabel className='mb-2' value="Better opportunities elsewhere" control={<Radio />} label="Better opportunities elsewhere" />

                            <FormControlLabel className='mb-2' value="Lack of clarity about the role or expectations" control={<Radio />} label="Lack of clarity about the role or expectations" />

                            <FormControlLabel className='mb-2' control={<Radio />} value={'other'} label="Others"
                            //  onClick={handleOtherReason}
                            />

                            {showOtherTextarea && (
                                <TextareaAutosize
                                    value={otherReason}
                                    onChange={handleOtherReasonChange}
                                    placeholder="Other Reason"
                                    minRows={5}
                                    maxRows={5}
                                />
                            )}
                        </RadioGroup>


                        <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'flex-end' }}>
                            <button
                                variant="contained"
                                className="common_btn"
                                style={{
                                    background: '#1c6597', color: '#fff', marginRight: '10px', width: "100px",
                                    height: "40px",
                                }}
                                disabled={loading}
                                onClick={handleSubmit} // Add your submit logic here
                            >
                                {!loading ? "Submit" : <SpinLoader />}
                            </button>
                            {/* <button
                                    className="btn btn-danger rounded-0"
                                    onClick={closeModal}
                                >
                                    Cancel
                                </button> */}
                        </div>
                    </FormControl>
                </DeactivateModal>
            </div>
            {renderData?.length > 0 &&
                <Pagination totalPages={totalPages} currentPage={pageNumber} onPageChange={handlePageChange} />
            }
        </>
    )
}

export default InterviewListTeamMember